module.exports = __webpack_public_path__ + "static/img/logoIPPS.08c7f99e.png";